import './Header.css';

interface HeaderProps {
    user: {
        name: string;
    } | null;
    signOut: () => void;
}

const Header: React.FC<HeaderProps> = ({
    user,
    signOut
}) => {
    return (
      <header className="header-component">
        <h1>Student-Teacher Ratio Monitor</h1>
        {user && (
          <div className="user-profile">
            <span>{user.name}</span>
            <button 
              onClick={signOut}
              className="sign-out-button-small"
            >
              Sign Out
            </button>
          </div>
        )}
      </header>
    )
}
export default Header;